let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("11PEA")).then(() => parcelRequire('j51e4'));